/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Multi Messaging Modal Reducer
 */

import { alwaysReducer, payloadReducer } from '@zcode/reducers'
import type { EmptyMultiMessageModal, MultiMessageModal } from '@zcode/state-type'
import { handleActions } from 'redux-actions'
import { CLEAR_DATA, RECEIVE_DATA } from '../constants/multiMessageModal'
import type { ActionTypes } from '../types'

const DEFAULT_STATE = {
  analyticChannel: '',
  dlcMessagedProperties: null,
  entity: null,
  fromNotifyMe: false,
  origin: '',
  postLeadData: null,
  similarListings: [],
} as const satisfies EmptyMultiMessageModal

export const multiMessageReducer = handleActions<MultiMessageModal, ActionTypes>(
  {
    [CLEAR_DATA]: alwaysReducer(DEFAULT_STATE),
    [RECEIVE_DATA]: payloadReducer,
  },
  DEFAULT_STATE
)
